var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-logout"},[_c('p',[_c('el-button',{attrs:{"type":"info","plain":""},on:{"click":_vm.logout}},[_vm._v("ログアウト")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }